var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.8 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #10519e;\n        stroke-width: 10px;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #10519e;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.33,
    y: 5,
    width: 85.33,
    height: 75.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.67,204.62v13.71c0,23.56-19.1,42.67-42.67,42.67h0c-23.56,0-42.67-19.1-42.67-42.67V80.09h85.33v16.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5,
    y1: 5,
    x2: 131.29,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.8,159.6c0,20.71-13.49,30.83-30.4,31.13-.21,0-.48.02-.7.02h0c-.26,0-.49-.02-.72-.02-16.91-.3-30.4-10.42-30.4-31.13,0-19.24,23.82-43.2,30.4-49.16.27-.27.5-.47.72-.65v-.02c.21.18.44.4.71.64,6.49,5.91,30.4,29.92,30.4,49.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset33);
export default __webpack_public_path__ + "static/media/Asset 33.461cc6c251d4a16dad148f5df98b5efb.svg";
export { ForwardRef as ReactComponent };